import { useEffect, useState } from "react";
import useEventListener from "@use-it/event-listener";

import "./App.css";
import Hangman from "./components/Hangman";
import Header from "./components/Header";
import Word from "./components/Word";
import Message from "./components/Message";

function App() {
  const [word, setWord] = useState([]);
  const [wrong, setWrong] = useState([]);
  const [letters, setLetters] = useState([]);
  const [step, setStep] = useState(0);
  const [gameState, setGameState] = useState("new");
  const [keyPressed, setKeyPressed] = useState(false);

  const getWord = () => {
    fetch("https://random-word-form.herokuapp.com/random/noun")
      .then((response) => response.text())
      .then((data) => {
        data = data.toUpperCase().slice(2, data.length - 2);
        data = data.split("");
        setWord(data);
      })
      .catch((error) => console.log(error));
  };

  const downHandler = (e) => {
    let key = e.key.toUpperCase();
    if (!keyPressed) {
      setKeyPressed(true);

      if (gameState === "play" || gameState === "same") {
        if (key.match(/[A-Z]/i) && key.length === 1 && wrong.length < 6) {
          if (letters.includes(key)) {
            setGameState("same");
          } else {
            const newLetters = [...letters, key];
            setLetters(newLetters);
            if (
              word.reduce((prev, cur) => prev && newLetters.includes(cur), true)
            )
              setGameState("won");
            else setGameState("play");

            if (!word.includes(key)) {
              if (wrong.length === 5) setGameState("lost");
              setWrong([...wrong, key]);
            }
          }
        }
      }
    }
  };

  const upHandler = () => {
    setKeyPressed(false);
  };

  useEventListener("keydown", downHandler);
  useEventListener("keyup", upHandler);

  useEffect(() => {
    setStep(wrong.length);
  }, [wrong]);

  useEffect(() => {
    if (gameState === "new") {
      setGameState("play");
      setLetters([]);
      setStep(0);
      setWrong([]);
      getWord();
    }
  }, [gameState]);

  return (
    <div className="app">
      <Header />
      <div className="main-container">
        <Hangman step={step} />
        <div className="right">
          <Word word={word} letters={letters} />
          <Message
            gameState={gameState}
            setGameState={setGameState}
            wrong={wrong}
            word={word}
          />
        </div>
      </div>
    </div>
  );
}

export default App;
